import { Component, Input } from '@angular/core';

/**
 * Device bezel around projected screen content.
 * `classic` is the dark bezel the SMS preview pages use; `console` is the
 * USSD simulator's handset in the bk language: no shadow, token colours, so
 * the screen follows the console's light and dark themes.
 */
@Component({
  selector: 'app-phone-frame',
  standalone: true,
  templateUrl: './phone-frame.component.html',
  styleUrl: './phone-frame.component.css',
})
export class PhoneFrameComponent {
  @Input() variant: 'classic' | 'console' = 'classic';
}
